import request from './request';

const review_submission = {
	async getApplication(id) {
		const response = await request.get(`/app/review-submission/id?id=${id}`);
		return response;
	},
	async submitApplication(id) {
		const response = await request.patch(`/app/review-submission/id?id=${id}`);
		return response;
	}
};

export default review_submission;